import { faEllipsisV } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Menu } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const ContextMenuStyle = styled.div`
  .button {
    height: 36px;
    min-width: 36px;
    align-items: center;
    text-align: center;
  }

  .icon {
    font-size: 36px;
    color: ${(p) => p.theme.palette.secondary.main};
  }
`;

const ContextMenu = ({ children }: { children: any }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <ContextMenuStyle>
      <Button variant="text" onClick={handleClick} className="button">
        <FontAwesomeIcon className="icon" icon={faEllipsisV} />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <div onClick={handleClose}>{children}</div>
      </Menu>
    </ContextMenuStyle>
  );
};

export default ContextMenu;
